import { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useTranslation } from "react-i18next";
import imgAbout1 from "../../../assets/img/projects/Effet_Mer/Effet_Mer-About1.png";
import imgAbout2 from "../../../assets/img/projects/Effet_Mer/Effet_Mer-About2.png";
import React from "react";

gsap.registerPlugin(ScrollTrigger);

export default function About() {
  const { t } = useTranslation();
  const containerRef = useRef(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: containerRef.current,
          start: "top 75%",
          end: "bottom top",
          toggleActions: "play none none reverse",
        },
      });

      const h1 = containerRef.current.querySelector("h1");
      const ps = containerRef.current.querySelectorAll("p");
      const imgs = containerRef.current.querySelectorAll("img");

      tl.fromTo(
        h1,
        { opacity: 0, y: 22, filter: "blur(2px)" },
        {
          opacity: 1,
          y: 0,
          filter: "blur(0px)",
          duration: 0.6,
          ease: "power2.out",
        }
      )
        .fromTo(
          ps,
          { opacity: 0, y: 22, filter: "blur(2px)" },
          {
            opacity: 1,
            y: 0,
            filter: "blur(0px)",
            duration: 0.6,
            ease: "power2.out",
            stagger: 0.12,
          },
          "-=0.48"
        )
        .fromTo(
          imgs[0],
          { opacity: 0, y: 22, x: -10, filter: "blur(2px)" },
          {
            opacity: 1,
            y: 0,
            x: 0,
            filter: "blur(0px)",
            duration: 0.6,
            ease: "power2.out",
          },
          "-=0.32"
        )
        .fromTo(
          imgs[1],
          { opacity: 0, y: 22, x: 10, filter: "blur(2px)" },
          {
            opacity: 1,
            y: 0,
            x: 0,
            filter: "blur(0px)",
            duration: 0.6,
            ease: "power2.out",
          },
          "-=0.44"
        );
    }, containerRef);

    return () => ctx.revert();
  }, []);

  return (
    <div className="Effet_Mer-about" ref={containerRef}>
      <div className="Effet_Mer-about-text">
        <article>
          <h1>{t("effetMer.about.title")}</h1>

          {t("effetMer.about.text")
            .split("\n")
            .map((para, i) => (
              <p key={i}>
                {para.split("\n").map((line, j) => (
                  <React.Fragment key={j}>
                    {line}
                    <br />
                  </React.Fragment>
                ))}
              </p>
            ))}
        </article>
      </div>

      <div className="Effet_Mer-about-image">
        <img src={imgAbout1} alt="Effet Mer About 1" />
        <img src={imgAbout2} alt="Effet Mer About 2" />
      </div>
    </div>
  );
}
